import React from "react";
import { Container, Row, Col } from "reactstrap";
import "../../styles/about-section.css";
import aboutImg from "../../assets/all-images/cars-img/bmw-offer.png";

const AboutSection = ({ aboutClass }) => {
  return (
    <section
      className="about__section "
      style={
        aboutClass === "aboutPage"
          ? { marginTop: "0px " }
          : { marginTop: "100px" }
      }
    >
      <Container>
        <Row>
          <Col lg="6" md="6">
            <div className="about__section-content">
              <h4 className="section__subtitle">Hakkımızda</h4>
              <h2 className="section__title">Ercan Havalimanın'da Araç Kiralama</h2>
              <p className="section__description">
              2010 yılından beri süregelen tecrübesiyle siz değerli müşterilerimize 
              uygun fiyatlarla Kıbrıs'ta araç kiralama hizmeti sunan firmamız sizi
               memnun etmenin gururunu yaşamaktadır. New Month Rent a Car firması olarak 
               Kuzey Kıbrıs - Girne ve Ercan Havalimanı'nda sizlere araç kiralama hizmeti sunmaktayız. 
               Sizlerin seyahatlerinizde bir aksilik yaşamamanız için araçlarımızın servisi 
               düzenli olarak yapılmaktadır. Araçlarımızın hepsi otomatik vites ve klimalıdır.
              </p>

              <div className="about__section-item d-flex align-items-center">

                <p className="section__description d-flex align-items-center gap-2">
                  <i className="ri-checkbox-circle-line"></i> Önceliğimiz müşteri memnuniyeti
                </p>

                <p className="section__description d-flex align-items-center gap-2">
                  <i className="ri-checkbox-circle-line"></i> Uygun fiyatlı kiralama hizmeti
                </p>
              </div>

              <div className="about__section-item d-flex align-items-center">
                <p className="section__description d-flex align-items-center gap-2">
                  <i className="ri-checkbox-circle-line"></i> Uzun vadeli kiralamalarda uygun fiyat
                </p>

                <p className="section__description d-flex align-items-center gap-2">
                  <i className="ri-checkbox-circle-line"></i> Otomatik Vites - Klimalı Araçlar
                </p>
              </div>
            </div>
          </Col>

          <Col lg="6" md="6">
            <div className="about__img">
              <img src={aboutImg} alt="" className="w-100" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;
